import { useEffect, useState } from 'react';
import Get from '../api/internal/Get';

export default function useDispatchOptions({
  branchIds,
}: {
  branchIds: string[];
}) {
  const [dispatchOptions, setDispatchOptions] =
    useState<DispatchOption[]>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const validBranchIds =
      branchIds?.filter(id => id && id.toString().trim() !== '') || [];

    if (validBranchIds.length > 0) {
      setIsLoading(true);
      const queryString = validBranchIds.map(id => `branchId=${id}`).join('&');
      Get(`Employee/GetDispatchOptions?${queryString}`)
        .then(response => {
          if (response) {
            setDispatchOptions(response.data);
          }
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setDispatchOptions(null);
      setIsLoading(false);
    }
  }, [branchIds]);

  return { dispatchOptions, isLoading };
}
